export default __webpack_public_path__ + "static/media/stamp.b3adad25.svg";